module.exports = __webpack_public_path__ + "static/media/05-江南第一茶楼.a7d4c8c8.png";